<template>
  <Scaffold :loading="loadingSharedResource" :identity="false" :showMenu="false">
    <template #topbar>
      <div class="project-topbar">
        <div v-if="!error && project && resource" class="project-details">
          <!-- <ProjectStatusSelect :value="project.status" :disabled="true" class="project-status-select" /> -->
          <div class="project-info">
            <p class="project-name">
              <template v-if="isDeliveryResource">
                <span style="display: inline-block; margin-right:5px;">Some finals assets are ready for your</span>
              </template>
              <template v-else>
                <span style="display: inline-block; margin-right:8px;">Welcome to your dedicated brief area, for</span>
              </template>
              <b>{{ project.name }}</b>
            </p>
            <p class="project-properties">
              From <b class="">{{resource.sharedBy.name}}</b> with <b>{{projectBrandNames}}</b>
            </p>
            <!-- <p class="project-properties"> -->
            <!-- {{ formatBrands(project.brands) }} -->
            <!-- <span v-if="project.dueDate"> &ndash; due {{ formatDueDate(project.dueDate) }}</span> -->
            <!-- </p> -->
          </div>
        </div>
      </div>
    </template>
    <div class="content">
      <template v-if="isDeliveryResource">
        <DeliverySharedResource :resource="resource" :description="description" :project="project" :token="token"></DeliverySharedResource>
      </template>
      <template v-if="isBriefResource">
        <BriefSharedResource :resource="resource.data" :description="description" :project="project" :token="token"></BriefSharedResource>
      </template>
    </div>
  </Scaffold>
</template>

<style lang="scss" scoped>
.project-properties{
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #6d7587;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  & b {
    font-weight: 500;
  }
}
.project-name{
  font-family: Roboto;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #000;
  margin-bottom: .5rem;
  & b{
    font-weight: 500;
  }
}
.project-status-select {
  margin-left: 100px;
}

.project-info {
  margin-left: 24px;
  flex-grow: 1;

  // .project-name {
  //   font-family: Roboto;
  //   font-size: 20px;
  //   color: #6d7587;
  // }

  // .project-properties {
  //   font-family: Roboto;
  //   font-size: 12px;
  //   line-height: 1.5;
  //   color: #6d7587;
  // }
}

.project-topbar {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 26px;
}

.project-details {
  height: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.max-w-md {
  max-width: 28rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.inset-0 {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.h-full {
  height: 100%;
}
.w-full {
  width: 100%;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.fixed {
  position: fixed;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.pt-20 {
  padding-top: 8.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.opacity-25 {
  opacity: 0.75;
}
.pt-4 {
  padding-top: 1rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.w-full {
  width: 100%;
}
.rounded-full {
  border-radius: 30px;
}
.rounded-md {
  border-radius: 10px;
}
.shadow-lg {
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
}
.shadow-md {
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
}
.bg-gradient-gray-500 {
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(275deg, #000000, white 0%), linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.font-semibold {
  font-weight: 500;
}
.font-normal {
  font-weight: normal;
}
.text-lg {
  font-size: 1.25rem;
}
.text-2xl {
  font-size: 1.75rem;
}
.leading-sm {
  line-height: 0.7;
}
.leading-loose {
  line-height: 1.5;
}
.text-md {
  font-size: 0.75rem;
}
.text-gray-500 {
  color: var(--fills-neutral-grey-dark);
}
.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.mt-4 {
  margin-top: 1rem;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.cursor-pointer {
  cursor: pointer;
}
.grid {
  display: grid;
}
.grid-cols-2 {
  grid-template-columns: 1fr 1fr;
}
.grid-cols-gap-6 {
  column-gap: 1.5rem;
}
.text-center {
  text-align: center;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.border-1 {
  border: solid 2px rgba(255, 255, 255, 0.16);
}

.list-actions {
  margin-bottom: 20px;
  display: flex;

  .select {
    flex-grow: 1;

    > * {
      margin-right: 23px;
    }
  }

  .actions {
    display: flex;

    > * {
      margin-left: 8px;
    }
  }
}

.droptarget {
  .placeholder {
    display: flex;
    justify-content: center;
    margin: 50px;
  }
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 12px 18px;

  &.upload-error {
    border-color: #f56c6c;
  }

  .checkbox {
    margin-right: 13px;
  }

  .thumbnail {
    width: 48px;
    margin-right: 12px;
  }

  .file-info {
    width: 250px;
    padding-right: 12px;

    &.uploading {
      width: auto;
      flex-grow: 1;
    }
  }

  .file-name {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .upload-error-message {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #f56c6c;
  }

  .platforms {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.form-row {
  align-items: flex-end;

  .checkbox {
    margin-bottom: 30px;
  }

  .actions {
    margin-bottom: 14px;
  }

  .form-item {
    margin: 0 10px;
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex';

import Scaffold from '@/components/layouts/Scaffold.vue';
import FinalAssetList from './delivery/FinalAssetList';
import PlatformList from '@/components/PlatformList.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';
import ProjectStatusSelect from '@/components/inputs/ProjectStatusSelect.vue';
import DeliverySharedResource from '@/views/workflow/sharing/DeliverySharedResource';
import BriefSharedResource from '@/views/workflow/sharing/BriefSharedResource';

export default {
  mixins: [projectViewHelpers],
  components: {
    PlatformList,
    Scaffold,
    ProjectStatusSelect,
    DeliverySharedResource,
    BriefSharedResource,
    FinalAssetList
  },
  data() {
    return {
      selectedAssets: []
    };
  },
  computed: {
    isBriefResource() {
      return this.resource && this.resource.type === 'brief';
    },
    isDeliveryResource() {
      return this.resource && ['delivery', 'working_files'].includes(this.resource.type);
    },
    ...mapState('workflow', {
      loadingSharedResource: state => state.sharedResource.loading,
      error: state => state.currentProject.error,
      resource: state => state.sharedResource.resource,
      project: state => state.sharedResource.project,
      token: state => state.sharedResource.token,
      description: state => state.sharedResource.description
    }),
    projectBrandNames() {
      return this.project.brands.map(b => b.name).join(', ');
    },
    assets() {
      return this.resource ? this.resource.data : [];
    }
  },
  methods: {
    isAssetSelected(asset) {
      return !!this.selectedAssets.find(a => a.id === asset.id);
    },
    handleSelectAllAssetsClick() {
      this.selectedAssets = this.assets;
    },
    handleUnselectAllAssetsClick() {
      this.selectedAssets = [];
    },
    handleAssetSelectedChange(asset, value) {
      if (value) {
        this.selectedAssets = [...this.selectedAssets, asset];
      } else {
        this.selectedAssets = this.selectedAssets.filter(a => a.id !== asset.id);
      }
    },
    handleDownloadAssetClick(asset) {
      window.open(asset.file.url, '_blank');
    },
    ...mapActions('workflow', ['fetchProjectResource'])
  },
  mounted() {
    this.fetchProjectResource({ token: this.$route.params.token });
  },
  watch: {
    error(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
